var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscribed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 5,
    viewBox: "0 0 17 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11758",
    "data-name": "Rectangle 11758",
    width: 17,
    height: 5,
    rx: 2.5,
    fill: "#00be9a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribed);
export default __webpack_public_path__ + "static/media/Subscribed.e911a25be752131661563b5095727018.svg";
export { ForwardRef as ReactComponent };